<template>
  <div class="scatter-bottom-info">
    {{ label }}
  </div>
</template>

<script>
export default { name: "BottomInfo", props: ["label"] };
</script>

<style lang="scss" scoped>
.scatter-bottom-info {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.05);
  bottom: 0;
  left: 0;
  padding: toRem(4) toRem(10);
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 17px;
  color: #efefef;
  opacity: 0.5;
}
</style>
